function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M165 173.21L238.667 102.435C248.014 92.7325 253.188 79.7275 253.073 66.2265C253.191 52.8837 248.053 40.0351 238.779 30.4823C229.504 20.9295 216.846 15.4473 203.564 15.231C196.17 15.2064 188.865 16.852 182.19 20.0459C175.515 23.2398 169.64 27.9004 165 33.6829C160.447 28.0076 154.704 23.4113 148.179 20.2218C141.655 17.0323 134.51 15.3282 127.254 15.231C120.608 15.2307 114.027 16.5528 107.893 19.121C101.758 21.6891 96.1899 25.4525 91.5108 30.1937C86.8316 34.935 83.1337 40.5602 80.6306 46.7448C78.1274 52.9293 76.8686 59.5506 76.9267 66.2265C76.8685 79.7776 82.1624 92.7989 91.6476 102.435L165 173.21Z",
  stroke: "url(#paint0_linear)",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M227.909 66.2277C228.093 73.0811 225.585 79.732 220.926 84.7428L165 138.203",
  stroke: "url(#paint1_linear)",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M109.579 84.7412C107.181 82.3004 105.286 79.4089 104.002 76.2319C102.717 73.055 102.068 69.655 102.093 66.2261C102.034 62.8697 102.642 59.5352 103.88 56.4173C105.119 53.2994 106.963 50.4604 109.306 48.0662C111.648 45.672 114.442 43.7705 117.524 42.4727C120.606 41.1749 123.915 40.5067 127.257 40.5072",
  stroke: "url(#paint2_linear)",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M278.238 141.614V78.4222C278.238 71.7185 280.889 65.2892 285.608 60.549C290.327 55.8087 296.727 53.1456 303.401 53.1456H309.692V198.486C309.751 208.88 305.754 218.884 298.557 226.353L249.047 277.855C243.534 283.735 240.472 291.514 240.492 299.592V312.231",
  stroke: "url(#paint3_linear)",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M165 312.23V277.096C165.003 266.204 167.163 255.421 171.353 245.376C175.544 235.33 181.681 226.222 189.408 218.58L222.436 185.847L248.984 137C250.699 133.996 253.353 131.644 256.534 130.309C259.715 128.974 263.245 128.731 266.578 129.616C269.911 130.502 272.86 132.467 274.968 135.207C277.076 137.948 278.225 141.31 278.237 144.773C278.21 147.402 277.54 149.984 276.286 152.293L238.541 221.803",
  stroke: "url(#paint4_linear)",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M51.7624 141.614V78.4222C51.7624 71.7185 49.1112 65.2892 44.3921 60.549C39.673 55.8087 33.2724 53.1456 26.5986 53.1456H20.3076V198.486C20.2985 208.852 24.2897 218.818 31.4426 226.29L80.9524 277.791C86.481 283.688 89.5437 291.492 89.5081 299.592V312.231",
  stroke: "url(#paint5_linear)",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M164.999 312.23V277.096C165.003 266.208 162.854 255.429 158.674 245.383C154.494 235.338 148.369 226.227 140.653 218.581L108.38 185.847L81.8323 137C80.4066 133.469 77.7536 130.578 74.366 128.863C70.9785 127.148 67.0865 126.726 63.4127 127.676C59.739 128.626 56.5331 130.882 54.3903 134.026C52.2475 137.171 51.3135 140.989 51.7616 144.773C51.7886 147.402 52.4583 149.984 53.7118 152.293L91.4575 221.803",
  stroke: "url(#paint6_linear)",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 54.6803,
  y1: 58.2945,
  x2: 275.151,
  y2: 108.926,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 157.054,
  y1: 85.8475,
  x2: 237.354,
  y2: 100.305,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 98.9107,
  y1: 52.565,
  x2: 131.623,
  y2: 56.3984,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 231.753,
  y1: 123.77,
  x2: 322.658,
  y2: 128.771,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 150.7,
  y1: 179.015,
  x2: 297.521,
  y2: 197.712,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 11.5689,
  y1: 123.77,
  x2: 102.473,
  y2: 128.771,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 37.3383,
  y1: 177.623,
  x2: 184.346,
  y2: 196.168,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00386572,
  stopColor: "#3E1D76"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#56CCF2"
})));

function SvgImage2HandsWithHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 330,
    viewBox: "0 0 330 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage2HandsWithHeart);
export default __webpack_public_path__ + "static/media/image_2_hands_with_heart.ed5c99e1.svg";
export { ForwardRef as ReactComponent };